import React, { useRef } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../supabase'

function Register() {

    let fname = useRef()
    let lname = useRef()
    let email = useRef()
    let password = useRef()



    let signup = async () => {
        let registerData = {
            email: email.current.value,
            password: password.current.value,
            options: {
                data: {
                    first_name: fname.current.value,
                    last_name: lname.current.value
                }
            }
        }

        const { data, error } = await supabase.auth.signUp(registerData);

        console.log(data, "data");
        console.log(error, "error");

    }


    return (
        <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
            data-sidebar-position="fixed" data-header-position="fixed">
            <div
                class="position-relative overflow-hidden text-bg-light min-vh-100 d-flex align-items-center justify-content-center">
                <div class="d-flex align-items-center justify-content-center w-100">
                    <div class="row justify-content-center w-100">
                        <div class="col-md-8 col-lg-6 col-xxl-3">
                            <div class="card mb-0">
                                <div class="card-body">
                                    <a href="./index.html" class="text-nowrap logo-img text-center d-block py-3 w-100">
                                        <img src="./assets/images/logos/logo.svg" alt="" />
                                    </a>
                                    <h2 class="text-center text-dark fw-bold ">Rkivedocs</h2>
                                    <form>
                                        <div class="mb-3">
                                            <label for="exampleInputtext1" class="form-label">First Name</label>
                                            <input type="text" class="form-control" id="exampleInputtext1" aria-describedby="textHelp" ref={fname} />
                                        </div>
                                        <div class="mb-3">
                                            <label for="exampleInputtext1" class="form-label">Last Name</label>
                                            <input type="text" class="form-control" id="exampleInputtext1" aria-describedby="textHelp" ref={lname} />
                                        </div>
                                        <div class="mb-3">
                                            <label for="exampleInputEmail1" class="form-label">Email Address</label>
                                            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" ref={email} />
                                        </div>
                                        <div class="mb-4">
                                            <label for="exampleInputPassword1" class="form-label">Password</label>
                                            <input type="password" class="form-control" id="exampleInputPassword1" ref={password} />
                                        </div>
                                        <Link to={'/login'} class="btn bg-dark text-white w-100 py-8 fs-4 mb-4 rounded-2" onClick={signup}>Sign Up</Link>
                                        <div class="d-flex align-items-center justify-content-center">
                                            <p class="mb-0">Already have an Account?</p>
                                            <Link to={'/login'} class="text-dark fw-bold ms-2" >Sign In</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register